module.exports = __webpack_public_path__ + "img/postgres.3a9a11a1.png";